<div class="container"
    style="display: flex; flex-direction: column; gap: 10px"
>
    <div *ngFor="let alert of alerts" class="{{ cssClass(alert) }} alert-dismissable" style="display: block;">
        {{alert.message}}
        <a class="close" (click)="removeAlert(alert)">&times;</a>
    </div>
</div>
